import { CameraRoll } from "@components/camera-roll";
import { Heading } from "@radix-ui/themes";
import { Page } from "@views/layout/layout";
import { useTranslation } from "react-i18next";
import { HomeSideBar } from ".";

export const CameraRollPage = (props: { trash?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Page verticalCenter={false}>
      <div className="w-full md:flex">
        <div className="">
          <HomeSideBar />
        </div>
        <div className="grow space-y-8">
          <div className="pb-4 w-full space-y-4">
            <div className="px-4 w-full">
              <Heading size="4">
                {props.trash
                  ? t("camera-roll.tabs.removed")
                  : t("camera-roll.title")}
              </Heading>
            </div>
            <CameraRoll trash={props.trash} />
          </div>
        </div>
      </div>
    </Page>
  );
};
